"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useConfig_1 = __importDefault(require("./../../../_util/useConfig"));
var LeftSide_1 = __importDefault(require("./LeftSide"));
var RightSide_1 = __importDefault(require("./RightSide"));
function SceneTabs(props) {
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var style = props.style, _a = props.data, data = _a === void 0 ? [] : _a;
    // 当前索引
    var _b = (0, react_1.useState)(0), activeTab = _b[0], setActiveTab = _b[1];
    // 场景切换状态
    var _c = (0, react_1.useState)(false), execute = _c[0], setExecute = _c[1];
    // 数据长度
    var dataLength = data.length;
    // 此时间须与样式设定的 progressBar 动画时间一致
    var autoSwitchTimeout = 10 * 1000;
    var timer = react_1.default.useRef();
    /**
     * 当前点击执行函数
     * @param index
     */
    var onChangeTab = function (index) {
        setExecute(true);
        setActiveTab(index);
        clearInterval(timer.current);
    };
    var autoRun = function () {
        setActiveTab(function (next) { return (next + 1) % dataLength; });
    };
    (0, react_1.useEffect)(function () {
        if (!timer.current) {
            timer.current = setInterval(autoRun, autoSwitchTimeout);
        }
    }, [activeTab]);
    (0, react_1.useEffect)(function () {
        return function () {
            timer.current && clearInterval(timer.current);
        };
    }, []);
    return (react_1.default.createElement("div", { style: style, className: "".concat(classPrefix, "-scenario-switch-pc") },
        react_1.default.createElement("section", { className: "".concat(classPrefix, "-scenario-main") },
            react_1.default.createElement(LeftSide_1.default, { data: data, onChangeTab: onChangeTab, activeTab: activeTab, execute: execute }),
            react_1.default.createElement(RightSide_1.default, { data: data, activeTab: activeTab }))));
}
exports.default = SceneTabs;
//# sourceMappingURL=index.js.map